(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revenue-calculator-v2"] && !Shopify.designMode) return;
  try {
    
class RevenueCalculatorV2 {
  constructor(root) {
    this.root = root;
    this.uplift = Number(root.dataset.uplift) / 100;
    this.currency = root.dataset.currency || 'AUD';

    this.revenueInput = root.querySelector('[data-input="revenue"]');
    this.revenueSlider = root.querySelector('[data-slider="revenue"]');

    this.bounds = {
      min: Number(root.dataset.revenueMin),
      max: Number(root.dataset.revenueMax),
      step: Number(root.dataset.revenueStep)
    };

    this.outputs = {
      annualIncrease: root.querySelector('[data-output="annual-increase"]'),
      monthlyIncrease: root.querySelector('[data-output="monthly-increase"]'),
      threeYearIncrease: root.querySelector('[data-output="three-year-increase"]')
    };

    this.positiveCurrencyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0,
      signDisplay: 'exceptZero'
    });

    this.numberFormatter = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0
    });

    this.bindEvents();
    this.formatInitialInput();
    this.syncSliderProgress();
    this.update();
  }

  formatInitialInput() {
    const revenue = this.parseNumber(this.revenueInput.value);

    if (revenue > 0) {
      this.revenueInput.value = this.numberFormatter.format(revenue);
      this.revenueSlider.value = this.clamp(revenue, this.bounds.min, this.bounds.max);
    }
  }

  bindEvents() {
    this.revenueSlider.addEventListener('input', () => {
      const value = Number(this.revenueSlider.value);
      this.revenueInput.value = this.numberFormatter.format(value);
      this.syncSliderProgress();
      this.update();
    });

    this.revenueInput.addEventListener('input', () => {
      const value = this.parseNumber(this.revenueInput.value);
      this.revenueInput.value = value ? this.numberFormatter.format(value) : '';
      this.revenueSlider.value = this.clamp(value, this.bounds.min, this.bounds.max);
      this.syncSliderProgress();
      this.update();
    });
  }

  parseNumber(value) {
    const digits = String(value).replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }

  clamp(value, min, max) {
    if (!value || value <= 0) {
      return min;
    }

    return Math.min(Math.max(value, min), max);
  }

  syncSliderProgress() {
    const min = Number(this.revenueSlider.min);
    const max = Number(this.revenueSlider.max);
    const value = Number(this.revenueSlider.value);
    const progress = ((value - min) / (max - min)) * 100;
    this.revenueSlider.style.setProperty('--slider-progress', `${progress}%`);
  }

  getRevenue() {
    return this.parseNumber(this.revenueInput.value);
  }

  update() {
    const revenue = this.getRevenue();

    if (!revenue || revenue <= 0) {
      this.setOutput('annualIncrease', '+$0');
      this.setOutput('monthlyIncrease', '+$0');
      this.setOutput('threeYearIncrease', '+$0');
      return;
    }

    const monthlyIncrease = revenue * this.uplift;
    const annualIncrease = monthlyIncrease * 12;
    const threeYearIncrease = annualIncrease * 3;

    this.setOutput('annualIncrease', this.formatPositive(annualIncrease));
    this.setOutput('monthlyIncrease', this.formatPositive(monthlyIncrease));
    this.setOutput('threeYearIncrease', this.formatPositive(threeYearIncrease));
  }

  setOutput(key, value) {
    if (this.outputs[key]) {
      this.outputs[key].textContent = value;
    }
  }

  formatPositive(value) {
    const formatted = this.positiveCurrencyFormatter.format(value);
    return formatted.startsWith('+') ? formatted : `+${formatted}`;
  }
}

function initRevenueCalculatorsV2(scope = document) {
  scope.querySelectorAll('.revcalc2').forEach((root) => {
    if (root.dataset.initialized === 'true') {
      return;
    }

    new RevenueCalculatorV2(root);
    root.dataset.initialized = 'true';
  });
}

initRevenueCalculatorsV2();

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initRevenueCalculatorsV2(event.target);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revenue-calculator"] && !Shopify.designMode) return;
  try {
    
class RevenueCalculator {
  constructor(root) {
    this.root = root;
    this.uplift = Number(root.dataset.uplift) / 100;
    this.currency = root.dataset.currency || 'AUD';

    this.visitorsInput = root.querySelector('[data-input="visitors"]');
    this.revenueInput = root.querySelector('[data-input="revenue"]');
    this.visitorsSlider = root.querySelector('[data-slider="visitors"]');
    this.revenueSlider = root.querySelector('[data-slider="revenue"]');

    this.bounds = {
      visitors: {
        min: Number(root.dataset.visitorsMin),
        max: Number(root.dataset.visitorsMax),
        step: Number(root.dataset.visitorsStep)
      },
      revenue: {
        min: Number(root.dataset.revenueMin),
        max: Number(root.dataset.revenueMax),
        step: Number(root.dataset.revenueStep)
      }
    };

    this.outputs = {
      currentRpv: root.querySelector('[data-output="current-rpv"]'),
      liftedRpv: root.querySelector('[data-output="lifted-rpv"]'),
      annualIncrease: root.querySelector('[data-output="annual-increase"]'),
      monthlyIncrease: root.querySelector('[data-output="monthly-increase"]'),
      threeYearIncrease: root.querySelector('[data-output="three-year-increase"]')
    };

    this.currencyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0
    });

    this.positiveCurrencyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0,
      signDisplay: 'exceptZero'
    });

    this.rpvFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    this.numberFormatter = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0
    });

    this.bindEvents();
    this.formatInitialInputs();
    this.syncSliderProgress();
    this.update();
  }

  formatInitialInputs() {
    const visitors = this.parseNumber(this.visitorsInput.value);
    const revenue = this.parseNumber(this.revenueInput.value);

    if (visitors > 0) {
      this.visitorsInput.value = this.numberFormatter.format(visitors);
      this.visitorsSlider.value = this.clamp(visitors, this.bounds.visitors.min, this.bounds.visitors.max);
    }

    if (revenue > 0) {
      this.revenueInput.value = this.numberFormatter.format(revenue);
      this.revenueSlider.value = this.clamp(revenue, this.bounds.revenue.min, this.bounds.revenue.max);
    }
  }

  bindEvents() {
    this.visitorsSlider.addEventListener('input', () => {
      const value = Number(this.visitorsSlider.value);
      this.visitorsInput.value = this.numberFormatter.format(value);
      this.syncSliderProgress();
      this.update();
    });

    this.revenueSlider.addEventListener('input', () => {
      const value = Number(this.revenueSlider.value);
      this.revenueInput.value = this.numberFormatter.format(value);
      this.syncSliderProgress();
      this.update();
    });

    this.visitorsInput.addEventListener('input', () => {
      const value = this.parseNumber(this.visitorsInput.value);
      this.visitorsInput.value = value ? this.numberFormatter.format(value) : '';
      this.visitorsSlider.value = this.clamp(value, this.bounds.visitors.min, this.bounds.visitors.max);
      this.syncSliderProgress();
      this.update();
    });

    this.revenueInput.addEventListener('input', () => {
      const value = this.parseNumber(this.revenueInput.value);
      this.revenueInput.value = value ? this.numberFormatter.format(value) : '';
      this.revenueSlider.value = this.clamp(value, this.bounds.revenue.min, this.bounds.revenue.max);
      this.syncSliderProgress();
      this.update();
    });
  }

  parseNumber(value) {
    const digits = String(value).replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }

  clamp(value, min, max) {
    if (!value || value <= 0) {
      return min;
    }

    return Math.min(Math.max(value, min), max);
  }

  syncSliderProgress() {
    [this.visitorsSlider, this.revenueSlider].forEach((slider) => {
      const min = Number(slider.min);
      const max = Number(slider.max);
      const value = Number(slider.value);
      const progress = ((value - min) / (max - min)) * 100;
      slider.style.setProperty('--slider-progress', `${progress}%`);
    });
  }

  getValues() {
    return {
      visitors: this.parseNumber(this.visitorsInput.value),
      revenue: this.parseNumber(this.revenueInput.value)
    };
  }

  update() {
    const { visitors, revenue } = this.getValues();

    if (!visitors || !revenue || visitors <= 0 || revenue <= 0) {
      this.outputs.currentRpv.textContent = '—';
      this.outputs.liftedRpv.textContent = '—';
      this.outputs.annualIncrease.textContent = '+$0';
      this.outputs.monthlyIncrease.textContent = '+$0';
      this.outputs.threeYearIncrease.textContent = '+$0';
      return;
    }

    const rpv = revenue / visitors;
    const liftedRpv = rpv * (1 + this.uplift);
    const monthlyIncrease = revenue * this.uplift;
    const annualIncrease = monthlyIncrease * 12;
    const threeYearIncrease = annualIncrease * 3;

    this.outputs.currentRpv.textContent = this.rpvFormatter.format(rpv);
    this.outputs.liftedRpv.textContent = this.rpvFormatter.format(liftedRpv);
    this.outputs.annualIncrease.textContent = this.formatPositive(annualIncrease);
    this.outputs.monthlyIncrease.textContent = this.formatPositive(monthlyIncrease);
    this.outputs.threeYearIncrease.textContent = this.formatPositive(threeYearIncrease);
  }

  formatPositive(value) {
    const formatted = this.positiveCurrencyFormatter.format(value);
    return formatted.startsWith('+') ? formatted : `+${formatted}`;
  }
}

function initRevenueCalculators(scope = document) {
  scope.querySelectorAll('.revcalc').forEach((root) => {
    if (root.dataset.initialized === 'true') {
      return;
    }

    new RevenueCalculator(root);
    root.dataset.initialized = 'true';
  });
}

initRevenueCalculators();

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initRevenueCalculators(event.target);
  });
}

  } catch(e) { console.error(e); }
})();
})();
